/*
 * @prop --wf-footer-disclaimer-font-size: The font size of the title.
 * @prop --wf-footer-disclaimer-font-weight: The font weight of the title.
 * @prop --wf-footer-disclaimer-font-size-large: The font weight of the title in medium and large viewports.
 */
:host {
    box-sizing: border-box;
    display: block;
    padding: 16px;
    background-color: var(--wf-footer-disclaimer-background-color, #f8f7f5);
}

.wf-footer-container {
    font-size: var(--wf-footer-disclaimer-font-size, 14px);
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: 32px;

    .additional-infos {
        color: var(--text-color-light);
        display: grid;
        grid-template-columns: 1fr;
        align-items: start;
        gap: 16px;
        line-height: 1.67;

        p {
            font-size: 0.8rem;
            margin: 8px 0;
            justify-content: flex-start;
        }
    }

    .terms {
        line-height: 1.71;

        a {
            color: currentcolor;
            text-decoration: none;

            &:not(:last-of-type)::after {
                content: ' | ';
                margin: 0 4px;
            }
        }

        &-disclaimer {
            color: var(--text-color-light, rgb(0 0 0 / 50%));
            margin-top: 8px;

            p {
                line-height: 1.67;
                font-size: 0.8rem;
                margin: 8px 0;
            }
        }
    }

}

@media screen and (min-width: 768px) {
    .wf-footer-container {
        .additional-infos {
            grid-template-columns: repeat(3, 1fr);

            .rewe, .partner {
                img {
                    margin-top: 20px;
                }
            }
        }
    }
}

@media screen and (min-width: 992px) {
    .wf-footer-container {
        grid-template-columns: repeat(2, 1fr);

        .additional-infos {
            p {
                line-height: 1.67;
                min-height: 32px;
            }

            .terms {
                margin-right: 40px;
            }
        }
    }
}
